import { render, staticRenderFns } from "./tab-shopix.vue?vue&type=template&id=ccfa2ba2&scoped=true"
import script from "./tab-shopix.vue?vue&type=script&lang=js"
export * from "./tab-shopix.vue?vue&type=script&lang=js"
import style0 from "./tab-shopix.vue?vue&type=style&index=0&id=ccfa2ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfa2ba2",
  null
  
)

export default component.exports